import { useState, useCallback } from 'react';
import { FormData, FormFiles } from '../types/ContactForm';

export const useFormData = () => {
  const [formData, setFormData] = useState<FormData>({});
  const [files, setFiles] = useState<FormFiles>({});

  const handleInputChange = useCallback((name: string, value: any) => {
    setFormData(prev => ({ ...prev, [name]: value }));
  }, []);

  const handleFileChange = useCallback((name: string, file: File | null) => {
    if (file) {
      setFiles(prev => ({ ...prev, [name]: file }));
    } else {
      setFiles(prev => {
        const newFiles = { ...prev };
        delete newFiles[name];
        return newFiles;
      });
    }
  }, []);

  const resetFormData = useCallback(() => {
    setFormData({});
    setFiles({});
  }, []);

  return {
    formData,
    files,
    handleInputChange,
    handleFileChange,
    resetFormData
  };
}; 